/* Browser-local favorites. Store handles only; fetch current Shopify data on opening. */
(() => {
  'use strict';
  const key = 'atelier-hancock:favorites:v1';
  const valid = handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle);
  const clean = value => Array.isArray(value) ? [...new Set(value.filter(valid))].slice(0, 100) : [];
  let items = [];
  let storageAvailable = true;
  try { items = clean(JSON.parse(localStorage.getItem(key) || '[]')); }
  catch { storageAvailable = false; }
  let generation = 0;
  let opener;
  const announce = text => { const el = document.getElementById('AhFavoriteStatus'); if (el) el.textContent = text; };
  const persist = () => {
    try { localStorage.setItem(key, JSON.stringify(items)); storageAvailable = true; }
    catch { storageAvailable = false; }
  };
  const sync = () => {
    document.querySelectorAll('[data-ah-favorite]').forEach(button => {
      const saved = items.includes(button.dataset.ahFavorite);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Retirer des favoris' : 'Ajouter aux favoris'} : ${button.dataset.title}`);
    });
    document.querySelectorAll('[data-ah-open-favorites]').forEach(button => { button.hidden = false; });
  };
  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const safeImage = value => {
    if (!value) return null;
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' || url.origin === location.origin ? url.href : null; }
    catch { return null; }
  };
  async function renderFavorites() {
    const dialog = document.getElementById('AhFavorites');
    if (!dialog?.open) return;
    const current = ++generation;
    const list = dialog.querySelector('[data-ah-favorites-list]');
    const status = dialog.querySelector('[data-ah-favorites-status]');
    const root = dialog.dataset.root || '/';
    list.replaceChildren();
    status.textContent = items.length ? 'Chargement de votre galerie…' : 'Votre galerie attend ses premiers coups de cœur.';
    const snapshot = [...items];
    let failures = 0;
    // Sequential batches keep a large saved list from flooding Shopify.
    for (let offset = 0; offset < snapshot.length; offset += 4) {
      const rows = await Promise.all(snapshot.slice(offset, offset + 4).map(async handle => {
        const row = node('article', '', 'ah-saved');
        const url = `${root}products/${encodeURIComponent(handle)}`;
        let product;
        let missing = false;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(`${url}.js`, {signal: controller.signal, headers: {Accept: 'application/json'}});
          missing = response.status === 404;
          if (!response.ok) throw new Error('Product fetch failed');
          product = await response.json();
          if (!product.title) throw new Error('Invalid product response');
        } catch { failures += 1; }
        finally { clearTimeout(timer); }
        if (product) {
          const src = safeImage(product.featured_image);
          if (src) {
            const image = node('img'); image.src = src; image.alt = ''; image.width = 72; image.height = 90; image.loading = 'lazy'; row.append(image);
          } else row.append(node('span'));
          const details = node('div');
          const anchor = node('a', product.title); anchor.href = url; details.append(anchor);
          if (!product.available) details.append(node('p', 'Actuellement indisponible', 'ah-saved__unavailable'));
          row.append(details);
        } else {
          row.append(node('span'));
          const details = node('div');
          const anchor = node('a', handle.replaceAll('-', ' ')); anchor.href = url; details.append(anchor);
          details.append(node('p', missing ? 'Ce produit n’est plus accessible.' : 'Impossible de charger ce produit pour le moment.', 'ah-saved__unavailable'));
          if (!missing) { const retry = node('button', 'Réessayer', 'ah-saved__retry'); retry.type = 'button'; retry.addEventListener('click', renderFavorites); details.append(retry); }
          row.append(details);
        }
        const remove = node('button', 'Retirer'); remove.type = 'button'; remove.setAttribute('aria-label', `Retirer des favoris : ${product?.title || handle}`);
        remove.addEventListener('click', () => {
          items = items.filter(item => item !== handle); persist(); sync();
          const target = row.nextElementSibling?.querySelector('button') || row.previousElementSibling?.querySelector('button') || document.getElementById('AhFavoritesTitle');
          row.remove(); target.focus();
          status.textContent = items.length ? 'Création retirée des favoris.' : 'Votre galerie attend ses premiers coups de cœur.';
          if (!storageAvailable) status.textContent += ' Stockage indisponible : la modification ne sera pas conservée après fermeture de la page.';
        });
        row.dataset.handle = handle; row.append(remove);
        return row;
      }));
      if (current !== generation || !dialog.open) return;
      rows.filter(row => items.includes(row.dataset.handle)).forEach(row => list.append(row));
    }
    if (current !== generation) return;
    if (snapshot.length) status.textContent = failures ? 'Certains produits n’ont pas pu être chargés. Vous pouvez réessayer ou les retirer.' : `${items.length} création${items.length > 1 ? 's' : ''} dans vos favoris.`;
    if (!storageAvailable) status.textContent += ' Le stockage de ce navigateur est indisponible : vos favoris sont temporaires.';
  }
  function init() {
    sync();
    const dialog = document.getElementById('AhFavorites');
    if (!dialog) return;
    dialog.addEventListener('close', () => { generation++; document.body.classList.remove('ah-favorites--open'); opener?.focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog && (event.clientX < dialog.getBoundingClientRect().left || event.clientX > dialog.getBoundingClientRect().right || event.clientY < dialog.getBoundingClientRect().top || event.clientY > dialog.getBoundingClientRect().bottom)) dialog.close(); });
    document.addEventListener('click', event => {
      const favorite = event.target.closest('[data-ah-favorite]');
      if (favorite) {
        const handle = favorite.dataset.ahFavorite;
        if (!valid(handle)) return;
        if (!items.includes(handle) && items.length >= 100) { announce('Votre galerie contient déjà 100 favoris. Retirez une création pour en ajouter une autre.'); return; }
        items = items.includes(handle) ? items.filter(item => item !== handle) : [...items, handle];
        persist(); sync();
        announce(`${items.includes(handle) ? 'Ajouté aux favoris.' : 'Retiré des favoris.'}${storageAvailable ? '' : ' Stockage indisponible : ces favoris sont temporaires.'}`);
      }
      const trigger = event.target.closest('[data-ah-open-favorites]');
      if (trigger) { opener = trigger; dialog.showModal(); document.body.classList.add('ah-favorites--open'); document.getElementById('AhFavoritesTitle').focus(); renderFavorites(); }
      if (event.target.closest('[data-ah-close]')) dialog.close();
    });
    document.addEventListener('shopify:section:load', sync);
    new MutationObserver(records => { if (records.some(record => record.addedNodes.length)) sync(); }).observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
    window.addEventListener('storage', event => {
      if (event.key !== key && event.key !== null) return;
      try { items = clean(JSON.parse(event.newValue || '[]')); } catch { items = []; }
      sync(); renderFavorites();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
